import React from 'react';
import PropTypes from 'prop-types';

import { reorderableList } from 'helpers/react_dnd/reorderable_list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons';

import ManagedInput from 'components/form/managed_input';

export const ATTRIBUTES = [
  { key: 'name', label: 'Name', width: '100%' },
  { key: 'size', label: 'Size' },
  { key: 'createdBy', label: 'Owner' },
  { key: 'lastModified', label: 'Date Modified' },
  { key: 'lastAccessed', label: 'Last Accessed' }
];

export class Table extends React.Component {
  static propTypes = {
    additionalColumns: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      width: PropTypes.string
    })),
    allSelected: PropTypes.bool,
    attributeOverrides: PropTypes.objectOf(PropTypes.shape({
      className: PropTypes.string,
      label: PropTypes.string,
    })),
    children: PropTypes.node,
    excludedColumns: PropTypes.arrayOf(PropTypes.string),
    sort: PropTypes.shape({
      key: PropTypes.string,
      reverse: PropTypes.bool
    }),
    onHeaderClick: PropTypes.func,
    onSelectAll: PropTypes.func
  }

  static defaultProps = {
    additionalColumns: [],
    excludedColumns: []
  }

  handleHeaderClick = (key) => {
    this.props.onHeaderClick(key);
  }

  renderArrow = () => {
    const icon = this.props.sort.reverse ? faArrowUp : faArrowDown;
    return <FontAwesomeIcon className="left-buffer-sm ms-2" icon={icon}/>;
  }

  renderColumnHeader = (attribute) => {
    const key = attribute.key;
    if (this.props.excludedColumns.includes(key)) return;

    const overrides = this.props.attributeOverrides && this.props.attributeOverrides[key];
    const { label, width } = { ...attribute, ...overrides };

    return (
      <th
        aria-label={`${key}Header`}
        className="clickable text-nowrap"
        data-name={key}
        key={key}
        name={key}
        width={width}
        onClick={() => this.handleHeaderClick(key)}
      >
        {label}
        {key == this.props.sort.key && this.renderArrow()}
      </th>
    );
  }

  renderColumnHeaders() {
    const columns = [...ATTRIBUTES];
    if (this.props.additionalColumns) {
      columns.push(...this.props.additionalColumns);
    }
    return columns.map(this.renderColumnHeader);
  }

  renderCheckbox() {
    return (
      <ManagedInput
        checked={this.props.allSelected}
        name="selected"
        type="checkbox"
        onChange={this.props.onSelectAll}
      />
    );
  }

  render() {
    if (this.props.children.length == 0) return <React.Fragment/>;

    return (
      <div className="table-container">
        <table className="table table-hover">
          <thead>
            <tr>
              {!this.props.excludedColumns.includes('select') && (
                <th style={{ width: 0 }}>{this.renderCheckbox()}</th>
              )}
              <th style={{ width: 0 }} />
              {this.renderColumnHeaders()}
              {!this.props.excludedColumns.includes('lastAccessed') && <th/>}
              <th style={{ width: 0 }}>
                {this.props.attributeOverrides?.actions?.label}
              </th>
            </tr>
          </thead>
          <tbody>
            {this.props.children}
          </tbody>
        </table>
      </div>
    );
  }
}

export default reorderableList(Table);
